import { CURRENCIES, createCurrencyFormatter } from '../utils/currency';
import { language } from '../utils/language';

const EUR = 'EUR';
const GBP = 'GBP';
const ZAR = 'ZAR';

const isSessionStorageAvailable = () => {
  try {
    if (typeof sessionStorage === 'object' && navigator.cookieEnabled)
      return true;
    else return false;
  } catch (e) {
    return false;
  }
};

class CurrencyFormatter {
  constructor(currency, millionsCharacter, value) {
    this.millionsCharacter = millionsCharacter;
    this.currency = currency;
    this.currencySign = CURRENCIES[this.currency] || '';
    this.value = value;
    this.stringValue = value.toString();
    this.separator = Intl.NumberFormat(language)
      .formatToParts(100000)
      .find((part) => part.type === 'group')?.value;
    this.formattedPrice = this.getFormattedPrice();
  }
  formatThousands() {
    return createCurrencyFormatter({ currency: this.currency, language })(
      this.value
    );
  }
  formatMillions() {
    let formattedPrice = this.stringValue.slice(0, -5).split('').reverse();
    if (this.separator === '.') {
      formattedPrice.splice(1, 0, ',');
    } else {
      formattedPrice.splice(1, 0, '.');
    }
    return `${this.currencySign}${formattedPrice.reverse().join('')} ${
      this.millionsCharacter
    }`;
  }
  formatTensOfMillions() {
    return `${this.currencySign}${this.stringValue.slice(0, -6)} ${
      this.millionsCharacter
    }`;
  }
  formatRest() {
    return `${this.currencySign}${this.stringValue}`;
  }
  getFormattedPrice() {
    if (this.value >= 5000000) {
      return this.formatTensOfMillions();
    } else if (this.value >= 1000000 && this.value < 5000000) {
      return this.formatMillions();
    } else if (this.value > 0) {
      return this.formatThousands();
    } else {
      return this.formatRest();
    }
  }
}

export default (
  regions,
  emptyRegion,
  initialRegion,
  prices,
  pricesRand,
  emptyPrice,
  millionsChar
) => ({
  initialRegion: initialRegion,
  millionsChar: millionsChar,
  emptyRegion: emptyRegion,
  locations: regions,
  selectedRegions: isSessionStorageAvailable()
    ? Alpine.$persist([]).using(sessionStorage)
    : [],
  openRegion: false,
  division: isSessionStorageAvailable()
    ? Alpine.$persist('').using(sessionStorage)
    : '',
  pricesRand: pricesRand,
  prices: prices,
  selectedPrice: isSessionStorageAvailable()
    ? Alpine.$persist('').using(sessionStorage)
    : '',
  emptyPrice: emptyPrice,
  openPrice: false,

  init() {
    this.$watch('isMaxPriceDisabled', (value) => {
      if (value) this.selectedPrice = '';
    });
    this.$watch('selectedPrice', () => {
      this.openPrice = false;
    });
    if (this.selectedRegions.length === 0 && this.initialRegion !== '') {
      this.selectedRegions.push(this.initialRegion);
    }
  },

  get selectedCurrencies() {
    return [
      ...new Set(
        this.selectedRegions.map(
          (selectedRegion) =>
            this.locations.find(
              (location) => location.culture_id === selectedRegion
            ).currency
        )
      ),
    ];
  },

  get getPriceList() {
    if (this.isMaxPriceDisabled) {
      return [];
    } else if (this.selectedCurrencies.includes(ZAR)) {
      return this.pricesRand.map(
        (price) => new CurrencyFormatter(ZAR, this.millionsChar, price)
      );
    } else if (this.selectedCurrencies.includes(GBP)) {
      return this.prices.map(
        (price) => new CurrencyFormatter(GBP, this.millionsChar, price)
      );
    }
    return this.prices.map(
      (price) => new CurrencyFormatter(EUR, this.millionsChar, price)
    );
  },

  get lastPriceItem() {
    if (this.getPriceList.length === 0) {
      return {};
    }
    return {
      formattedPrice:
        this.getPriceList[this.getPriceList.length - 1].formattedPrice + '+',
      value: '',
    };
  },

  get regionDisplayNames() {
    if (this.selectedRegions.length === 0) {
      return this.emptyRegion;
    }
    return this.selectedRegions
      .map(
        (region) =>
          this.locations.find((location) => location.culture_id === region).name
      )
      .join(', ');
  },

  get priceDisplay() {
    if (this.selectedPrice === '') {
      return this.emptyPrice;
    }
    return this.selectedPrice.formattedPrice;
  },

  isDivisionSelected: function (division) {
    return this.division === division ? 'active' : '';
  },

  get isMaxPriceDisabled() {
    return this.selectedCurrencies.length !== 1;
  },
});
